module.exports = __webpack_public_path__ + "static/kiran-f55f16d79f819132b5e4211ed48264b4.jpg";